import React, { FunctionComponent } from "react";
import { HeroCta } from "../cta/HeroCta";
import * as HeroIcons from "@heroicons/react/outline";
import Section from "../layout/Section";
import HeroTitle from "../typography/HeroTitle";
import LeadText from "../typography/LeadText";
import TitleTag from "../typography/TitleTag";

type IconHeroProps = {
  tag: string;
  title: JSX.Element;
  description: string;
  icon: JSX.Element;
  topCta?: JSX.Element;
  cta?: JSX.Element;
};

const IconHero: FunctionComponent<IconHeroProps> = ({
  tag,
  title,
  description,
  icon,
  topCta,
  cta = <HeroCta />,
}) => {
  return (
    <div className="w-full bg-gray-900">
      <Section className="mt-0 flex flex-wrap">
        <div className="order-2 lg:order-1 pb-12 my-auto lg:pr-10 xl:pr-0 lg:w-7/12 xl:w-1/2">
          {topCta ?? <TitleTag>{tag}</TitleTag>}
          <HeroTitle className="mt-2 mb-3">
            <span className="text-gray-100">{title}</span>
          </HeroTitle>
          <LeadText>
            <span className="text-gray-300">{description}</span>
          </LeadText>
          {cta}
        </div>
        <div className="hidden lg:flex content-center order-1 lg:py-3 lg:px-7 m-auto lg:w-5/12 xl:w-1/3 max-h-80 lg:max-h-144">
          {icon}
        </div>
        <svg
          className={`hidden md:block absolute h-1/3 w-1/3 -top-24 right-0 xl:-right-9 text-gray-700 opacity-70`}
        >
          <defs>
            <pattern
              id="squares-pattern"
              x="0"
              y="0"
              width="40"
              height="40"
              patternUnits="userSpaceOnUse"
            >
              <path
                fill="currentColor"
                d="M6 18h12V6H6v12zM4 4h16v16H4V4z"
              ></path>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#squares-pattern)" />
        </svg>
        <svg className="hidden md:block absolute h-24 w-2/3 -left-20 opacity-70 bottom-0">
          <rect width="100%" height="100%" fill="url(#squares-pattern)" />
        </svg>
      </Section>
    </div>
  );
};

export default IconHero;
